import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './shared/components/toast/toast';
import { DialogComponent } from './shared/components/dialog/dialog';
import { ThemeCustomizerComponent } from './shared/components/theme-customizer/theme-customizer';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent, DialogComponent, ThemeCustomizerComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <router-outlet/>
    <app-toast/>
    <app-dialog/>
    <app-theme-customizer/>
  `,
})
export class App {}
